import { ISubTaskMeetTemplate } from '@dadohr/shared/domainTypes/experience';
import { CustomUserField } from '@dadohr/shared/domainTypes/org';
import { MenuItem } from '@material-ui/core';
import { capitalize } from 'lodash';
import { DataFieldWithLabel } from '../../../../../../../../components/DataFieldWithLabel';
import { FormRow } from '../../../../../../../../components/Form/FormRow';
import { SelectCustom } from '../../../../../../../../components/SelectCustom';
import { meetWithPersonAsText } from '../../../../../../../../components/SubTask';
import { useTranslation } from '../../../../../../../../i18next';

const ALL_ROLES: ISubTaskMeetTemplate['data']['role'][] = [
  'MENTOR',
  'MANAGER',
  'SKIP_LEVEL_MANAGER',
  'TEAM',
  'HR'
];

export const BlockSettingsSubTaskMeet = ({
  value,
  onChange
}: {
  value: ISubTaskMeetTemplate;
  onChange: (nextValue: ISubTaskMeetTemplate) => void;
  customFields: CustomUserField[];
}) => {
  const { t } = useTranslation();
  return (
    <FormRow>
      <SelectCustom
        autoFocus
        fullWidth
        value={value.data.role}
        label={capitalize(t('subTask.meet.verb'))}
        variant="outlined"
        onChange={(ev) => {
          const role = ev.target.value as ISubTaskMeetTemplate['data']['role'];
          onChange({
            ...value,
            data: {
              ...value.data,
              role
            }
          });
        }}
      >
        {ALL_ROLES.map((role) => (
          <MenuItem key={role} value={role}>
            {meetWithPersonAsText(role, t)}
          </MenuItem>
        ))}
      </SelectCustom>
    </FormRow>
  );
};

export const BlockSettingsSubTaskMeetReadOnly = ({
  value
}: {
  value: ISubTaskMeetTemplate;
}) => {
  const { t } = useTranslation();
  return (
    <FormRow>
      <DataFieldWithLabel label={capitalize(t('subTask.meet.verb'))}>
        {meetWithPersonAsText(value.data.role, t)}
      </DataFieldWithLabel>
    </FormRow>
  );
};
